<table class="table table-transparent table-responsive">
  <tbody>
    <tr>
      <td>
        <span class="po-desc-label" translate="ebook.createdBy"></span>
      </td>
      <td>
        <span class="po-value-label">{{::eBookSavings.createdBy}}</span>
      </td>
    </tr>
    <tr>
      <td>
        <span class="po-desc-label" translate="accounts.accParentAccountIban">IBAN</span>
      </td>
      <td>
        <span class="po-value-label">{{::eBookSavings.iban}}</span>
      </td>
    </tr>
    <tr ng-if="eBookSavings.eSavingBookNumber">
      <td>
        <span class="po-desc-label" translate="ebook.ebookNumber">Account number</span>
      </td>
      <td>
        <span class="po-value-label">{{::eBookSavings.eSavingBookNumber}}</span>
      </td>
    </tr>
    <tr>
      <td>
        <span class="po-desc-label" translate="ebook.requestType">Request type</span>
      </td>
      <td>
        <span class="po-value-label">{{::eBookSavings.requestType}}</span>
      </td>
    </tr>
    <tr>
      <td>
        <span class="po-desc-label" translate="ebook.status"></span>
      </td>
      <td>
        <span class="po-value-label">{{::eBookSavings.status}}</span>
      </td>
    </tr>
  </tbody>
</table>
